import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const ScrollTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          onClick={scrollToTop}
          aria-label="Back to Top"
          initial={{ opacity: 0, scale: 0, y: 50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0, y: 50 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="fixed right-6 bottom-44 z-50 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-[#D4AF37] to-[#f0d060] text-[#0B1F3A] shadow-2xl hover:shadow-[0_8px_30px_rgba(212,175,55,0.5)] group"
        >
          <FaArrowUp
            size={18}
            className="group-hover:-translate-y-0.5 transition-transform duration-300"
          />
          {/* Tooltip */}
          <span className="absolute right-14 hidden whitespace-nowrap rounded-lg bg-[#0B1F3A]/95 backdrop-blur-sm px-3 py-1.5 text-xs font-medium text-white shadow-xl border border-white/10 lg:block">
            Back to Top
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollTop;